import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "scan",
  "description": "`turbo scan` 命令的 API 参考"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "使用一个交互式命令，在本地为你的 Turborepo 启用更快的工具。"
  }, {
    "heading": "",
    "content": "¥Enable faster tooling for your Turborepo locally with one, interactive command."
  }, {
    "heading": "",
    "content": "你将完成一系列简短的步骤，以启用 Turborepo 的最快设置。这些优化包括："
  }, {
    "heading": "",
    "content": "¥You'll be taken through a short series of steps to enable the fastest settings for your Turborepo. These optimizations include:"
  }, {
    "heading": "",
    "content": "Git 文件系统监控：turbo 依靠 Git 进行文件变更发现。由于我们必须等待 git 告知我们更改，因此可以使用 Git 的内置文件系统监视器 更快地获取这些通知。"
  }, {
    "heading": "",
    "content": "¥Git FS Monitor: turbo leans on Git to do file change discovery. Since we have to wait for git to tell us about changes, we can use Git's built-in filesystem monitor to get those notifications sooner."
  }, {
    "heading": "",
    "content": "Turborepo 守护进程：Turborepo 的守护进程会在后台乐观地理解你的存储库。通过预先完成 turbo 在运行任务时需要做的共享、通用工作，turbo 将更快地运行你的任务。"
  }, {
    "heading": "",
    "content": "¥Turborepo Daemon: Turborepo's daemon optimistically understands your repository in the background. By doing shared, common work that turbo will need to do when running tasks beforehand, turbo will run your tasks faster."
  }, {
    "heading": "",
    "content": "远程缓存：Turborepo 不仅可以在本地缓存你的工作，还可以在所有机器上共享缓存。启用 远程缓存 可使你的缓存功能多人协作，确保你、你的队友以及你的 CI 机器不会重复执行相同的工作。"
  }, {
    "heading": "",
    "content": "¥Remote Caching: While Turborepo can cache your work locally, it can also share a cache across all of your machines. Enabling Remote Caching makes your caching multiplayer, ensuring that you, your teammates, and your CI machines, never do the same work twice."
  }, {
    "heading": "",
    "content": "检查 turbo 版本：我们一直在努力改进 turbo。为确保你使用的是最新版本的 Turborepo，我们将检查你的版本，如果你尚未使用 latest，请提醒你安装。"
  }, {
    "heading": "",
    "content": "¥Check turbo version: We're always working towards making turbo better. To ensure you are using the latest version of Turborepo, we'll check your version and remind you to install latest if you aren't using it yet."
  }, {
    "heading": "",
    "content": "检查 Turborepo LSP：访问 VSCode 扩展市场 并为你的 IDE 安装 Turborepo LSP 扩展。"
  }, {
    "heading": "",
    "content": "¥Check for Turborepo LSP:\nVisit the VSCode Extension Marketplace and install the Turborepo LSP extension for your IDE."
  }],
  "headings": []
};
export const toc = [];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: "使用一个交互式命令，在本地为你的 Turborepo 启用更快的工具。"
    }), "\n", _jsx(_components.p, {
      children: "¥Enable faster tooling for your Turborepo locally with one, interactive command."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " scan"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "你将完成一系列简短的步骤，以启用 Turborepo 的最快设置。这些优化包括："
    }), "\n", _jsx(_components.p, {
      children: "¥You'll be taken through a short series of steps to enable the fastest settings for your Turborepo. These optimizations include:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Git 文件系统监控：", _jsx(_components.code, {
            children: "turbo"
          }), " 依靠 Git 进行文件变更发现。由于我们必须等待 ", _jsx(_components.code, {
            children: "git"
          }), " 告知我们更改，因此可以使用 ", _jsx(_components.a, {
            href: "https://git-scm.com/docs/git-fsmonitor--daemon",
            children: "Git 的内置文件系统监视器"
          }), " 更快地获取这些通知。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.strong, {
            children: "Git FS Monitor"
          }), ": ", _jsx(_components.code, {
            children: "turbo"
          }), " leans on Git to do file change discovery. Since we have to wait for ", _jsx(_components.code, {
            children: "git"
          }), " to tell us about changes, we can use ", _jsx(_components.a, {
            href: "https://git-scm.com/docs/git-fsmonitor--daemon",
            children: "Git's built-in filesystem monitor"
          }), " to get those notifications sooner."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Turborepo 守护进程：Turborepo 的守护进程会在后台乐观地理解你的存储库。通过预先完成 ", _jsx(_components.code, {
            children: "turbo"
          }), " 在运行任务时需要做的共享、通用工作，", _jsx(_components.code, {
            children: "turbo"
          }), " 将更快地运行你的任务。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.strong, {
            children: "Turborepo Daemon"
          }), ": Turborepo's daemon optimistically understands your repository in the background. By doing shared, common work that ", _jsx(_components.code, {
            children: "turbo"
          }), " will need to do when running tasks beforehand, ", _jsx(_components.code, {
            children: "turbo"
          }), " will run your tasks faster."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["远程缓存：Turborepo 不仅可以在本地缓存你的工作，还可以在所有机器上共享缓存。启用 ", _jsx(_components.a, {
            href: "/docs/core-concepts/remote-caching",
            children: "远程缓存"
          }), " 可使你的缓存功能多人协作，确保你、你的队友以及你的 CI 机器不会重复执行相同的工作。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.strong, {
            children: "Remote Caching"
          }), ": While Turborepo can cache your work locally, it can also share a cache across all of your machines. Enabling ", _jsx(_components.a, {
            href: "/docs/core-concepts/remote-caching",
            children: "Remote Caching"
          }), " makes your caching ", _jsx(_components.strong, {
            children: "multiplayer"
          }), ", ensuring that you, your teammates, and your CI machines, never do the same work twice."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["检查 ", _jsx(_components.code, {
            children: "turbo"
          }), " 版本：我们一直在努力改进 ", _jsx(_components.code, {
            children: "turbo"
          }), "。为确保你使用的是最新版本的 Turborepo，我们将检查你的版本，如果你尚未使用 ", _jsx(_components.code, {
            children: "latest"
          }), "，请提醒你安装。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsxs(_components.strong, {
            children: ["Check ", _jsx(_components.code, {
              children: "turbo"
            }), " version"]
          }), ": We're always working towards making ", _jsx(_components.code, {
            children: "turbo"
          }), " better. To ensure you are using the latest version of Turborepo, we'll check your version and remind you to install ", _jsx(_components.code, {
            children: "latest"
          }), " if you aren't using it yet."]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["检查 Turborepo LSP：访问 ", _jsx(_components.a, {
            href: "https://marketplace.visualstudio.com/items?itemName=Vercel.turbo-vsc",
            children: "VSCode 扩展市场"
          }), " 并为你的 IDE 安装 Turborepo LSP 扩展。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.strong, {
            children: "Check for Turborepo LSP"
          }), ":\nVisit the ", _jsx(_components.a, {
            href: "https://marketplace.visualstudio.com/items?itemName=Vercel.turbo-vsc",
            children: "VSCode Extension Marketplace"
          }), " and install the Turborepo LSP extension for your IDE."]
        }), "\n"]
      }), "\n"]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
